import { render } from "./DocumentContainer.vue?vue&type=template&id=230c24aa&scoped=true"
import script from "./DocumentContainer.vue?vue&type=script&lang=js"
export * from "./DocumentContainer.vue?vue&type=script&lang=js"

import "./DocumentContainer.vue?vue&type=style&index=0&id=230c24aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230c24aa"]])

export default __exports__